import { connect } from 'react-redux';

import EndOperation from './end-operation.component';
import { emitOperationEndingStatus } from './end-operation.actions';
import { IEndOperationDispatchProps } from 'modules/end-operation/end-operation.types';

const mapDispatchToProps: IEndOperationDispatchProps = {
    emitOperationEndingStatus
};

const Container = connect(
    null,
    mapDispatchToProps
)(EndOperation);

export default Container;
